import { IKnmSignatureInfo } from 'APIPackage/KnmModule/interfaces/IKnmSignatureInfo';
import { KnmSignatureInfoStatusesEnum } from 'APIPackage/KnmModule/enums/KnmSignatureInfoStatusesEnum';

export const getSignStatus = (status: IKnmSignatureInfo['status'], errorMessage: IKnmSignatureInfo['errorMessage']) => {
  switch (status) {
    case KnmSignatureInfoStatusesEnum.VALID:
      return 'Проверена';
    case KnmSignatureInfoStatusesEnum.INVALID:
      return `Ошибка проверки подлинности. ${errorMessage || ''}`;
    case KnmSignatureInfoStatusesEnum.IN_PROCESS:
    default:
      return 'Проверяется системой';
  }
};
